

export namespace Timer
{
    /**
     * Creates a promise to be fulfilled after a certain delay.
     * @param delay Delay to wait before fulfilling the promise.
     * @returns The promise.
     */
    export function wait(delay: number): Promise<void>
    {
        return (
            new Promise(
                onComplete =>
                    setTimeout(onComplete, delay)
            )
        );
    }
}
